import React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';
import { SiFacebook, SiTiktok, SiYoutube } from 'react-icons/si';

const renderIcon = (Icon: IconType, props?: IconBaseProps) =>
  React.createElement(Icon as unknown as React.FC<IconBaseProps>, props);

const SocialLinks: React.FC = () => {
  const socials = [
    { 
      icon: renderIcon(SiFacebook), 
      label: 'Facebook', 
      href: 'https://www.facebook.com/nexlanka' 
    },
    { 
      icon: renderIcon(SiTiktok), 
      label: 'TikTok', 
      href: 'https://www.tiktok.com/@nex_computer' 
    },
    { 
      icon: renderIcon(SiYoutube), 
      label: 'YouTube', 
      href: 'https://www.youtube.com/@nexlanka' 
    },
  ];

  return (
    <div className="flex items-center gap-2">
      {socials.map((social) => (
        <a
          key={social.label}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.label}
          className="flex h-8 w-8 items-center justify-center rounded-lg border border-indigo-500/30 text-slate-300 transition hover:border-indigo-400 hover:bg-indigo-500/20 hover:text-indigo-200"
        >
          {social.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
